
import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { MapPlacesGridService } from './map-places-grid.service';


@Directive({
  selector: '[placeGridLayerIcon]',
  standalone: true
})
export class PlaceGridLayerIconDirective implements OnInit {

  @Input('placeGridLayerIcon') layerIcon: string;

  #MapPlacesGridService = inject(MapPlacesGridService);

  constructor(private element: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.element.nativeElement.className = this.element.nativeElement.className + ' ' + this.getCssClassList();
  }

  getCssClassList(): string {
    return this.#MapPlacesGridService.getLayerIcon(this.layerIcon);
  }





}

